

export const USER_OPENS_CART_SIDEBAR = 'user_opens_checkout_sidebar';
export const USER_CLOSES_CART_SIDEBAR = 'user_closes_checkout_sidebar';
export const PRODUCT_ADDED_TO_CART = 'product_added_to_cart';
